import React from 'react';
import './analysis.css'

const Swaps = ({swaps}) => {
    return (
        <div className='analysis'>
            Swaps: {swaps}
        </div>
    );
}

export default Swaps;
